import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Button } from "./ui/button";
import { Trophy, Clapperboard, LogOut, Wrench, Camera, BookOpen, Briefcase } from "lucide-react";

export default function Header() {
  const { user, signOut, isRegional } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const linkCls = (p) => `px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${loc.pathname === p ? "bg-white/15 text-white" : "text-slate-300 hover:text-white hover:bg-white/10"}`;

  return (
    <header className="sw-navy sticky top-0 z-40 border-b-2 border-[#c8102e] pt-[env(safe-area-inset-top)]" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center gap-2 group" data-testid="header-logo">
          <div className="w-9 h-9 sw-red rounded-md flex items-center justify-center">
            <Wrench className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight">
            <span className="font-display font-800 text-white text-lg font-bold tracking-tight">SITE WARS</span>
            <span className="hidden sm:block text-[10px] uppercase tracking-[0.2em] text-slate-400">Redstone Residential · July 2026</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          <Link to="/how-it-works" className={linkCls("/how-it-works")} data-testid="nav-how-it-works"><BookOpen className="w-4 h-4 inline mr-1 -mt-0.5" /><span className="hidden sm:inline">How it works</span></Link>
          <Link to="/" className={linkCls("/")} data-testid="nav-leaderboard"><Trophy className="w-4 h-4 inline mr-1 -mt-0.5" /><span className="hidden sm:inline">Leaderboard</span></Link>
          {user && <Link to="/feed" className={linkCls("/feed")} data-testid="nav-feed"><Camera className="w-4 h-4 inline mr-1 -mt-0.5" /><span className="hidden sm:inline">The Feed</span></Link>}
          <Link to="/reels" className={linkCls("/reels")} data-testid="nav-reels"><Clapperboard className="w-4 h-4 inline mr-1 -mt-0.5" /><span className="hidden sm:inline">Reels</span></Link>
          {user?.role === "property_user" && <Link to="/dashboard" className={linkCls("/dashboard")} data-testid="nav-dashboard">My Property</Link>}
          {(isRegional || user?.role === "admin") && <Link to="/portfolio" className={linkCls("/portfolio")} data-testid="nav-portfolio"><Briefcase className="w-4 h-4 inline mr-1 -mt-0.5" /><span className="hidden sm:inline">My Portfolio</span></Link>}
          {(user?.role === "judge" || user?.role === "admin") && <Link to="/judge" className={linkCls("/judge")} data-testid="nav-judge">Judging</Link>}
          {user?.role === "admin" && <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">Admin</Link>}
          {user ? (
            <Button size="sm" variant="ghost" className="text-slate-300 hover:text-white hover:bg-white/10 ml-1" onClick={async () => { await signOut(); nav("/"); }} data-testid="sign-out-btn">
              <LogOut className="w-4 h-4" /><span className="hidden sm:inline ml-1">Sign out</span>
            </Button>
          ) : (
            <>
              <Link to="/login" className={linkCls("/login")} data-testid="nav-login">Sign in</Link>
              <Link to="/register" data-testid="nav-register">
                <Button size="sm" className="sw-red hover:bg-red-700 text-white ml-1 font-semibold">Register</Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
